import { render, staticRenderFns } from "./FlexCard.vue?vue&type=template&id=2c775ba4&scoped=true&"
import script from "./FlexCard.vue?vue&type=script&lang=js&"
export * from "./FlexCard.vue?vue&type=script&lang=js&"
import style0 from "./FlexCard.vue?vue&type=style&index=0&id=2c775ba4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c775ba4",
  null
  
)

export default component.exports